import { z } from "zod";
import { metaSchema, sortBySchema } from "./commun.zod";
import { GroupeSchema } from "./groupe.zod";
import { ProfilSchema } from "./profil.zod";

export const UserBaseSchema = z.object({
  nom: z
    .string()
    .min(1, "Le nom est requis")
    .max(255, "Le nom ne peut pas dépasser 255 caractères")
    .nullable()
    .optional(),
  prenom: z
    .string()
    .min(1, "Le prénom est requis")
    .max(255, "Le prénom ne peut pas dépasser 255 caractères")
    .nullable()
    .optional(),
  username: z
    .string()
    .min(1, "Le nom d'utilisateur est requis")
    .max(255, "Le nom d'utilisateur ne peut pas dépasser 255 caractères")
    .nullable()
    .optional(),
  email: z
    .string()
    .email("Email invalide")
    .max(255, "L'email ne peut pas dépasser 255 caractères")
    .nullable()
    .optional(),
  password: z
    .string()
    .min(6, "Le mot de passe doit contenir au moins 6 caractères")
    .max(255, "Le mot de passe ne peut pas dépasser 255 caractères")
    .nullable()
    .optional(),
  is_active: z.boolean().default(true).optional(),
  email_active: z.boolean().default(false).optional(),
  is_init: z.boolean().default(false).optional(),
  img: z
    .string()
    .max(255, "L'URL de l'image ne peut pas dépasser 255 caractères")
    .nullable()
    .optional(),
  is_root: z.boolean().default(false).optional(),
  deleted: z.boolean().default(false).optional(),
  city: z
    .string()
    .max(255, "La ville ne peut pas dépasser 255 caractères")
    .nullable()
    .optional(),
  phone_number: z
    .string()
    .max(255, "Le numéro de téléphone ne peut pas dépasser 255 caractères")
    .nullable()
    .optional(),
  zip_code: z
    .string()
    .max(255, "Le code postal ne peut pas dépasser 255 caractères")
    .nullable()
    .optional(),
  address: z
    .string()
    .max(255, "L'adresse ne peut pas dépasser 255 caractères")
    .nullable()
    .optional(),
  address2: z
    .string()
    .max(255, "L'adresse 2 ne peut pas dépasser 255 caractères")
    .nullable()
    .optional(),
  profil_id: z
    .number()
    .int()
    .positive("L'ID du profil doit être un nombre positif"),
  groupe_id: z
    .number()
    .int()
    .positive("L'ID du groupe doit être un nombre positif"),
  profil: ProfilSchema,
  groupe: GroupeSchema,
});

export const UserSchema = UserBaseSchema.extend({
  id: z.number().int().positive(),
  created_at: z.date().nullable().optional(),
  updated_at: z.date().nullable().optional(),
});

export const UserCreateSchema = UserBaseSchema.pick({
  nom: true,
  prenom: true,
  username: true,
  email: true,
  password: true,
  is_active: true,
  email_active: true,
  is_init: true,
  img: true,
  is_root: true,
  deleted: true,
  city: true,
  phone_number: true,
  zip_code: true,
  address: true,
  address2: true,
  profil_id: true,
  groupe_id: true,
});

export const UserUpdateSchema = z.object({
  id: z.number().int().positive(),
  nom: z
    .string()
    .min(1, "Le nom est requis")
    .max(255, "Le nom ne peut pas dépasser 255 caractères")
    .nullable()
    .optional(),
  prenom: z
    .string()
    .min(1, "Le prénom est requis")
    .max(255, "Le prénom ne peut pas dépasser 255 caractères")
    .nullable()
    .optional(),
  username: z
    .string()
    .min(1, "Le nom d'utilisateur est requis")
    .max(255, "Le nom d'utilisateur ne peut pas dépasser 255 caractères")
    .nullable()
    .optional(),
  email: z
    .string()
    .email("Email invalide")
    .max(255, "L'email ne peut pas dépasser 255 caractères")
    .nullable()
    .optional(),
  password: z
    .string()
    .min(6, "Le mot de passe doit contenir au moins 6 caractères")
    .max(255, "Le mot de passe ne peut pas dépasser 255 caractères")
    .nullable()
    .optional(),
  is_active: z.boolean().optional(),
  email_active: z.boolean().optional(),
  is_init: z.boolean().optional(),
  img: z
    .string()
    .max(255, "L'URL de l'image ne peut pas dépasser 255 caractères")
    .nullable()
    .optional(),
  is_root: z.boolean().optional(),
  deleted: z.boolean().optional(),
  city: z
    .string()
    .max(255, "La ville ne peut pas dépasser 255 caractères")
    .nullable()
    .optional(),
  phone_number: z
    .string()
    .max(255, "Le numéro de téléphone ne peut pas dépasser 255 caractères")
    .nullable()
    .optional(),
  zip_code: z
    .string()
    .max(255, "Le code postal ne peut pas dépasser 255 caractères")
    .nullable()
    .optional(),
  address: z
    .string()
    .max(255, "L'adresse ne peut pas dépasser 255 caractères")
    .nullable()
    .optional(),
  address2: z
    .string()
    .max(255, "L'adresse 2 ne peut pas dépasser 255 caractères")
    .nullable()
    .optional(),
  profil_id: z
    .number()
    .int()
    .positive("L'ID du profil doit être un nombre positif")
    .optional(),
  groupe_id: z
    .number()
    .int()
    .positive("L'ID du groupe doit être un nombre positif")
    .optional(),
});

export const UserListResponseSchema = z.object({
  data: z.array(UserSchema),
  meta : metaSchema
});

export const UserResponseSchema = z.object({
  data: UserSchema,
  message: z.string().optional(),
});

export const UserSelectSchema = z.object({
  id: z.number().int().positive().optional(),
  nom: z.string().optional(),
  prenom: z.string().optional(),
  username: z.string().optional(),
  email: z.string().optional(),
  is_active: z.boolean().optional(),
  email_active: z.boolean().optional(),
  is_init: z.boolean().optional(),
  deleted: z.boolean().optional(),
  city: z.string().optional(),
  profil_id: z.number().int().positive().optional(),
  groupe_id: z.number().int().positive().optional(),
  includeDeleted: z.boolean().default(false),
  includeInactive: z.boolean().default(false),
    limit: z.number().default(10),
  page: z.number().default(1),
  search: z.string().optional(),
    sortBy: sortBySchema
});

export const UserLoginSchema = z.object({
  email: z.string().email("Email invalide"),
  password: z.string().min(1, "Le mot de passe est requis"),
});

export const UserRegisterSchema = z.object({
  nom: z.string().min(1, "Le nom est requis").max(255),
  prenom: z.string().min(1, "Le prénom est requis").max(255),
  username: z.string().min(1, "Le nom d'utilisateur est requis").max(255),
  email: z.string().email("Email invalide").max(255),
  password: z
    .string()
    .min(6, "Le mot de passe doit contenir au moins 6 caractères")
    .max(255),
  profil_id: z
    .number()
    .int()
    .positive("L'ID du profil doit être un nombre positif"),
  groupe_id: z
    .number()
    .int()
    .positive("L'ID du groupe doit être un nombre positif"),
});

export type User = z.infer<typeof UserSchema>;

export type UserCreateInput = z.infer<typeof UserCreateSchema>;
export type UserUpdateInput = z.infer<typeof UserUpdateSchema>;
export type UserSelectInput = z.infer<typeof UserSelectSchema>;
export type UserLoginInput = z.infer<typeof UserLoginSchema>;
export type UserRegisterInput = z.infer<typeof UserRegisterSchema>;

// Form-specific types for frontend
export type UserFormData = Omit<
  UserCreateInput,
  "is_active" | "email_active" | "is_init" | "is_root" | "deleted"
> & {
  is_active?: boolean;
  email_active?: boolean;
  is_init?: boolean;
  is_root?: boolean;
  deleted?: boolean;
};

export type UserEditFormData = Omit<UserUpdateInput, "id">;

// Utility types for different UI states
export type UserDisplayItem = Pick<
  User,
  "id" | "nom" | "prenom" | "username" | "email" | "is_active" | "city"
>;
export type UserSelectOption = Pick<User, "id" | "nom" | "prenom" | "username">;
export type UserTableItem = Pick<
  User,
  | "id"
  | "nom"
  | "prenom"
  | "username"
  | "email"
  | "is_active"
  | "email_active"
  | "city"
  | "created_at"
  | "updated_at"
>;
export type UserProfile = Omit<User, "password">;

export type UserResponse = z.infer<typeof UserResponseSchema>;
export type UserListResponse = z.infer<typeof UserListResponseSchema>;

export const validateUserCreate = (data: unknown) => {
  return UserCreateSchema.safeParse(data);
};

export const validateUserUpdate = (data: unknown) => {
  return UserUpdateSchema.omit({ id: true }).safeParse(data);
};

export const validateUserSelect = (data: unknown) => {
  return UserSelectSchema.safeParse(data);
};

export const validateUserLogin = (data: unknown) => {
  return UserLoginSchema.safeParse(data);
};

export const validateUserRegister = (data: unknown) => {
  return UserRegisterSchema.safeParse(data);
};

export const LoginSchema = z.object({
  email: z.string().min(1, "Email ou nom d'utilisateur requis"),
  password: z.string().min(1, "Mot de passe requis"),
});

export const RegisterSchema = UserCreateSchema;

export const RefreshTokenSchema = z.object({
  refreshToken: z.string().min(1, "Token de rafraîchissement requis"),
});

export const PasswordResetRequestSchema = z.object({
  email: z.string().email("Email invalide"),
});

export const PasswordResetSchema = z
  .object({
    token: z.string().min(1, "Token requis"),
    password: z
      .string()
      .min(8, "Le mot de passe doit contenir au moins 8 caractères"),
    passwordConfirm: z
      .string()
      .min(
        8,
        "La confirmation du mot de passe doit contenir au moins 8 caractères",
      ),
  })
  .refine((data) => data.password === data.passwordConfirm, {
    message: "Les mots de passe ne correspondent pas",
    path: ["passwordConfirm"],
  });

export const ChangePasswordSchema = z
  .object({
    currentPassword: z.string().min(1, "Mot de passe actuel requis"),
    newPassword: z
      .string()
      .min(8, "Le nouveau mot de passe doit contenir au moins 8 caractères"),
    passwordConfirm: z
      .string()
      .min(
        8,
        "La confirmation du mot de passe doit contenir au moins 8 caractères",
      ),
  })
  .refine((data) => data.newPassword === data.passwordConfirm, {
    message: "Les mots de passe ne correspondent pas",
    path: ["passwordConfirm"],
  });

export const AuthResponseSchema = z.object({
  user: UserSchema.omit({ password: true }),
  token: z.string(),
  refreshToken: z.string(),
  expiresIn: z.number(),
});

// Types pour l'authentification
export type LoginInput = z.infer<typeof LoginSchema>;
export type RegisterInput = z.infer<typeof RegisterSchema>;
export type RefreshTokenInput = z.infer<typeof RefreshTokenSchema>;
export type PasswordResetRequestInput = z.infer<
  typeof PasswordResetRequestSchema
>;
export type PasswordResetInput = z.infer<typeof PasswordResetSchema>;
export type ChangePasswordInput = z.infer<typeof ChangePasswordSchema>;
export type AuthResponse = z.infer<typeof AuthResponseSchema>;

// Fonctions de validation pour l'authentification
export const validateLogin = (data: unknown) => {
  return LoginSchema.safeParse(data);
};

export const validateRegister = (data: unknown) => {
  return RegisterSchema.safeParse(data);
};

export const validatePasswordResetRequest = (data: unknown) => {
  return PasswordResetRequestSchema.safeParse(data);
};

export const validatePasswordReset = (data: unknown) => {
  return PasswordResetSchema.safeParse(data);
};

export const validateChangePassword = (data: unknown) => {
  return ChangePasswordSchema.safeParse(data);
};

export const validateRefreshToken = (data: unknown) => {
  return RefreshTokenSchema.safeParse(data);
};
